import { Injectable } from '@angular/core';

import { BehaviorSubject, Subject } from 'rxjs';

export type CvActionsData = {
  editable: boolean;
  isCvEmpty: boolean;
  loading: boolean;
  originalUrl: string;
  url: string;
  processing: boolean;
  anonymizationFailed: boolean;
};

@Injectable()
export class CvActionsService {
  public inputClick$ = new Subject<void>();
  public deleteClick$ = new Subject<void>();
  public reparseClick$ = new Subject<void>();

  public actionsData$: BehaviorSubject<CvActionsData> = new BehaviorSubject({
    editable: false,
    isCvEmpty: true,
    loading: true,
    processing: false,
    originalUrl: '',
    url: '',
    anonymizationFailed: false,
  });
}
